export class EmailAcuerdo {

    id: number;
    direccion: string;
    
}



// WEBPACK FOOTER //
// ./src/app/acuerdo/email-acuerdo.model.ts